import { BSCNetwork, EthereumNetwork } from '@/constants';

export function isTestNetwork(chainId: number | string): boolean {
  const testNetworks = [...EthereumNetwork.testnet, ...BSCNetwork.testnet];
  return testNetworks.includes(+chainId);
}

export function isOnEthereumNetwork(chainId: number | string): boolean {
  const ethereumNetwork = [
    ...EthereumNetwork.mainnet,
    ...EthereumNetwork.testnet,
  ];
  return ethereumNetwork.includes(+chainId);
}

export function isOnBSCNetwork(chainId: number | string): boolean {
  const bscNetwork = [...BSCNetwork.mainnet, ...BSCNetwork.testnet];
  return bscNetwork.includes(+chainId);
}
